import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useContext } from "react";
import { APIContext } from "../Contexts/APIContext";
import { TelemetryContext } from "../Contexts/TelemetryContext";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import FileOpenIcon from '@mui/icons-material/FileOpen';

interface IProps {
    type: "pdf" | "help" | "dialog";
    buttonLabel?: string;
    colour: "info" | "error" | "warning";
    icon: "triangle" | "file" | "help";

    dialogTitle?: string;
    dialogContent?: React.ReactNode;

    pdfContainer?: string;
    pdfFile?: string;

    helpPage?: string;
}

const tooltips: Record<string, string> = {
    pdf: "Open Information Document",
    help: "Open Help Page",
    dialog: "More Information",
};
const colours: Record<string, string> = {
    info: "#1976D2",
    error: "#D32F2F",
    warning: "#FFBF00",
};

export default function AdditionalInfo(props: IProps) {
    const { getPDF, openDialog } = useContext(APIContext);
    const { logFileAccess } = useContext(TelemetryContext);

    const handleClick = () => {
        switch (props.type) {
            case "pdf":
                logFileAccess(props.pdfFile, "AdditionalInfo");
                getPDF(
                    'Document',
                    `GetLibraryFile?folder=${props.pdfContainer}&fileName=${props.pdfFile}`,
                    props.buttonLabel ?? props.pdfFile!,
                    true
                );
                break;
            case "help":
                const url = `/help?page=${props.helpPage}`;
                window.open(url, '_blank');
                break;
            case "dialog":
                openDialog(props.dialogContent, [], props.dialogTitle);
                break;
            default:
                break;
        }
    }

    return (
        <Tooltip title={tooltips[props.type]}>
            {props.buttonLabel ?
                <Button onClick={handleClick}>{props.buttonLabel}</Button>
                :
                <IconButton onClick={handleClick} size="small">
                    {props.icon === "triangle" ?
                        <WarningAmberIcon htmlColor={colours[props.colour]} />
                        : props.icon === "file" ?
                            <FileOpenIcon htmlColor={colours[props.colour]} />
                            :
                            <LiveHelpIcon htmlColor={colours[props.colour]} />
                    }
                </IconButton>
            }
        </Tooltip>
    );
}
